<template>
    <div class="question-item" v-if="show !== false">
        <div class="question-title">
            <TextTemplate :text="`${question.indexNo}. ${question.content}`" />
            <ImagePreview :picUrl="question.picUrl" />
        </div>

        <div class="list">
            <div @click="onChange(opt)" class="item" v-for="opt in question.options" :key="opt.id">
                <div class="title" :class="{ active: opt.title === answer }">{{ opt.title }}</div>
                <div class="content" v-if="!isUrl(opt.content)">{{ opt.content }}</div>
                <div class="content" v-else>
                    <img :src="opt.content" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TextTemplate from '../../TextTemplate.vue'
import ImagePreview from '../../ImagePreview.vue'

export default {
    components: { TextTemplate, ImagePreview },
    props: ['show', 'question'],
    data() {
        return {
            answer: '',
        }
    },
    created() {
        if (this.question.stashAnswer) {
            this.answer = this.question.stashAnswer[0] || ''
        }
        this.updateStoreData()
    },
    methods: {
        onChange(opt) {
            this.answer = opt.title
            this.updateStoreData('edit')
            setTimeout(() => {
                this.$emit('next')
            }, 100)
        },
        updateStoreData(type) {
            const { id } = this.question
            if (type === 'edit') {
                this.$store.dispatch('paperDetails/updateUserAnswer', { id, answer: [this.answer] })
            }
            let data = null
            if (this.answer) {
                data = { state: true, answer: [this.answer] }
            }
            this.$store.dispatch('paperDetails/setUserAnswerMap', { [`q-${id}`]: data })
        },
        isUrl(text) {
            const urlPattern = /^(https?:\/\/|www\.)/i
            return urlPattern.test(text)
        },
    },
}
</script>
<style lang="scss" scoped>
.list {
    padding-top: 20px;
    .item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .title {
            width: 36px;
            height: 36px;
            border-radius: 42px;
            border: 1px solid #eeeeee;
            color: #999;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;
            flex-shrink: 0;
        }
        .active {
            color: #ffffff;
            background: #ff8c00;
            border-color: #ff8c00;
        }
        .content {
            font-size: 16px;
            line-height: 1.6em;
            img {
                width: 120px;
            }
        }
    }
}
</style>
